// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"slider_carouselWrapper__a1F-d","carouselItems":"slider_carouselItems__Nx1dW","carouselItem":"slider_carouselItem__cOihn"};